module.exports = __webpack_public_path__ + "static/media/blingV3_18.708c24f6.png";